import { ArrowRight } from 'lucide-react'
import { TELEGRAM_BOT_URL } from '@/lib/constants'
import { useScrollReveal } from '@/hooks/useScrollReveal'

export function FinalCta() {
  const ref = useScrollReveal<HTMLElement>()

  return (
    <section ref={ref} className="relative overflow-hidden bg-panel/40 border-y border-border">
      {/* Glow background */}
      <div
        className="pointer-events-none absolute inset-0 opacity-20"
        style={{
          background:
            'radial-gradient(ellipse 60% 50% at 50% 50%, rgb(var(--jl-brand) / 0.3), transparent 70%)',
        }}
      />

      <div className="relative max-w-3xl mx-auto px-5 py-20 text-center">
        <div className="reveal">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand mb-4">
            Empieza ahora
          </p>
          <h2 className="font-display text-4xl sm:text-5xl font-extrabold">
            Prueba John Anthony{' '}
            <span className="text-brand">gratis</span>
          </h2>
          <p className="mt-4 text-text-dim text-base max-w-md mx-auto leading-relaxed">
            Sin tarjeta, sin compromiso. Abre Telegram y empieza en menos de un minuto.
            5 días con el plan Free completo.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={TELEGRAM_BOT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-brand text-base px-8 py-4 rounded-2xl animate-glow-pulse"
            >
              Abrir en Telegram
              <ArrowRight className="h-5 w-5" />
            </a>
          </div>

          <p className="mt-5 text-xs text-text-dim">
            Sin tarjeta · Cancela cuando quieras · +5.000 partidos analizados
          </p>
        </div>
      </div>
    </section>
  )
}
